<template>
    <div v-if="!params.node.rowPinned">
        <b-button class="align-baseline mr-2" title="Print" variant="default" :href="onPrintToPdf()">
            <font-awesome-icon :icon="['fas', 'print']"></font-awesome-icon>
        </b-button>
        <b-button class="align-baseline mr-2" title="Edit" variant="default" @click="onEditModalOpen">
            <font-awesome-icon :icon="['fas', 'pen-to-square']"></font-awesome-icon>
        </b-button>
        <b-button
            v-if="canDelete"
            class="align-baseline"
            title="Delete"
            variant="default"
            @click="isDeleteDialogShown = true"
        >
            <font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon>
        </b-button>
        <modal
            id="work-order-delete-modal"
            title="Delete"
            ok-title="Delete"
            @hide="isDeleteDialogShown = false"
            @cancel="isDeleteDialogShown = false"
            @ok="onDelete"
            :visible="isDeleteDialogShown"
            >Are you sure you want to delete work order #{{ selectedItem.id || '' }}?</modal
        >
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Modal from '../../generic/modal/modal.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            Modal,
            ResponsiveButton,
        },
        data() {
            return {
                isDeleteDialogShown: false,
            };
        },
        computed: {
            ...mapGetters('workOrders', ['metadata']),
            selectedItem() {
                return this.params.data;
            },
            canDelete() {
                return this.metadata.permissions && this.metadata.permissions.can_delete;
            },
        },
        methods: {
            onEditModalOpen() {
                this.params.modalData.openEditModal(this.params.data);
            },
            onPrintToPdf() {
                return this.params.modalData.onPrintToPdf(this.params.data) || '';
            },
            onDelete() {
                this.params.modalData.onDelete(this.params.data);
            },
        },
    });
</script>

<style scoped lang="scss">

</style>
